/* variant-selected-color.js
   Päivittää Color-otsikon perään valitun värinimen – ei riipu input-nimistä
--------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  /* 1) Etsi legend, jonka teksti alkaa 'Color' (välilyönneillä ei väliä) */
  const colorLegend = [...document.querySelectorAll('legend')].find(l =>
    l.textContent.trim().toLowerCase().startsWith('color')
  );
  if (!colorLegend) return;                      // tällä tuotteella ei värioptiota

  /* 2) span johon arvo kirjoitetaan (lisättiin liquidissä)             */
  const output = colorLegend.querySelector('#selected-color');
  if (!output) return;

  /* 3) Radiobuttonit löytyvät samasta fieldsetistä                      */
  const fieldset = colorLegend.closest('fieldset');
  const radioInputs = fieldset
    ? fieldset.querySelectorAll('input[type="radio"]')
    : [];

  /* Jos teema käyttää dropdownia värille, radiot puuttuvat             */
  if (radioInputs.length === 0) {
    const selectInput = fieldset.querySelector('select');
    if (!selectInput) return;
    const refresh = () => (output.textContent = selectInput.value);
    selectInput.addEventListener('change', refresh);
    refresh();
    return;
  }

  /* 4) Päivitä arvo aina kun radiota klikataan                         */
  function refresh() {
    const checked = [...radioInputs].find(r => r.checked);
    if (checked) output.textContent = checked.value;
  }

  radioInputs.forEach(r => r.addEventListener('change', refresh));
  refresh();                                   // näytä heti sivulatauksessa
});

